import { render } from "./tabbar.vue?vue&type=template&id=65322247&scoped=true&ts=true"
import script from "./tabbar.vue?vue&type=script&lang=ts"
export * from "./tabbar.vue?vue&type=script&lang=ts"

import "./tabbar.vue?vue&type=style&index=0&id=65322247&lang=less&scoped=true"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65322247"]])

export default __exports__